// The email typed on the sign-in page's email step, remembered for this tab so
// the discovery callback can notice when OAuth returns a different address
// (Microsoft's login_hint only pre-fills; the account chosen there wins).
export const SIGNIN_TYPED_EMAIL_KEY = 'signin_typed_email';

export const rememberSigninEmail = (email: string): void => {
  try {
    window.sessionStorage.setItem(SIGNIN_TYPED_EMAIL_KEY, email);
  } catch {
    // Best-effort; the mismatch check is skipped without it.
  }
};

export const readSigninEmail = (): string => {
  try {
    return window.sessionStorage.getItem(SIGNIN_TYPED_EMAIL_KEY) ?? '';
  } catch {
    return '';
  }
};

export const forgetSigninEmail = (): void => {
  try {
    window.sessionStorage.removeItem(SIGNIN_TYPED_EMAIL_KEY);
  } catch {
    // Ignore storage failures.
  }
};

export const isSameEmail = (a: string, b: string): boolean =>
  a.trim().toLowerCase() === b.trim().toLowerCase();
